import Vue from 'vue';
import supplierTransformer from './../../transformers/supplier';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentSupplier', supplierTransformer.fetch(data));
  resolve(supplierTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(supplierTransformer.fetch(errors));
};

export default (id, supplier) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/suppliers/${id}`, supplier)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/supplier/update.js